import { ApplicationConfig } from "../config/ApplicationConfig";

export class RestClient<Dto> {
  private readonly baseUrl: string;

  private readonly credentials: RequestCredentials;

  constructor(apiUrl: string) {
    const { baseUrl, credentials } = new ApplicationConfig().getRestConfig();
    this.baseUrl = baseUrl + apiUrl;
    this.credentials = credentials;
  }

  async get(path: string) {
    const url = `${this.baseUrl}${path}`;
    const response = await fetch(url, {
      method: "GET",
      credentials: this.credentials,
    });

    if (!response.ok) RestClient.throwNotOk(response);
    return response.json();
  }

  async post(path: string, body: Omit<Dto, "id">) {
    const url = `${this.baseUrl}${path}`;
    const response = await fetch(url, {
      method: "POST",
      credentials: this.credentials,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) RestClient.throwNotOk(response);
    return response.json();
  }

  async put(path: string, body: Dto) {
    const url = `${this.baseUrl}${path}`;
    const response = await fetch(url, {
      method: "PUT",
      credentials: this.credentials,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) RestClient.throwNotOk(response);
    return response;
  }

  async delete(path: string) {
    const url = `${this.baseUrl}${path}`;
    const response = await fetch(url, {
      method: "DELETE",
      credentials: this.credentials,
    });

    if (!response.ok) RestClient.throwNotOk(response);
    return response;
  }

  private static throwNotOk({ statusText, url }: Response): never {
    throw new Error(
      `Error while getting saved search from backend. Status not ok: ${statusText}. At URL: ${url}`
    );
  }
}
